import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
  Card,
  Typography,
  IconButton,
  Icon
} from '@material-ui/core';
import {deleteAdditionalSpecialsApi} from 'api/subscription';


const SpecialsList = ({setSpecial}) => {
  const dispatch = useDispatch();
  const { additionalSpecials } = useSelector((state) => state.subscription);

  return (
    <div>
      {additionalSpecials.map((element) => (
        <Card
          className="p-4 m-4 flex justify-between items-center"
          key={element._id}
        >
          <Typography variant="h6" className="text-brand">{element.value}</Typography>
          <div>
            <IconButton
              className="mr-2"
              title="Edit"
              onClick={() => setSpecial(element)}
            >
              <Icon className="text-gray">edit</Icon>
            </IconButton>
            <IconButton
              className="mr-2"
              title="Delete"
              onClick={() => deleteAdditionalSpecialsApi({dispatch, id: element._id})}
            >
              <Icon className="text-gray">delete</Icon>
            </IconButton>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default SpecialsList;
